export const CROSS_PAGE_ACTIONS_COOKIE = 'trackPWANav';
export const PREVIOUS_MONOLITH_ACTIONS_COOKIE = 'trackNav';

export const MAX_COOKIE_LENGTH = 4096;

export const CROSS_PAGE_ACTION_NAMES = {
    trackThemedSearchClick: 'trackThemedSearchClick',
};
